import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TransitionOverlayService } from '@core/services/transition-overlay.service';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.css'
})
export class AuthLayout implements OnInit {
  private overlayService = inject(TransitionOverlayService);
  ngOnInit(): void {
    // Apagar el overlay de transición: ya estamos en el login
    this.overlayService.hide();
  }

}